import React from 'react'
import i18next from 'i18next'
import { connect } from 'react-redux'
import hash from 'object-hash'
import axios from 'src/lib/axios'
import { Modal, Button, Card, Alert, DropdownButton, Dropdown } from 'react-bootstrap'
import ActionsDropdown from 'src/components/system_wide/actions_dropdown'
import SearchButton from 'src/components/system_wide/search_button'
import ResponsiveTable from 'src/components/system_wide/responsive_table'
import DealerForm from './dealer_form'
import {
  setCurrentDealer,
  createDealer,
  updateDealer,
  deleteDealer,
  toggleShowForm,
  getDealers,
  resetCurrentDealer,
  resetDealers,
  updateErrors,
} from 'src/store/dealers'
import { Trans } from 'react-i18next'
import { checkCapabilities, WithCapabilitiesWrapper } from 'src/enhancers/with_capabilities'
import { getAllBrands } from 'src/store/brand'
import { getAllCategories } from 'src/store/category'
import { getAllUsers } from 'src/store/users'
import FilterGroup from '../system_wide/filter_group'
import CheckboxFilter from '../system_wide/checkbox_filter'
import SelectAgentsModal from '../system_wide/select_agents_modal'
import { startOfToday, format } from 'date-fns'
import { showConfirmDialog } from '../system_wide/confirm_dialog'
import RadiolistFilter from '../system_wide/radiolist_filter'
import { getConstants } from 'src/lib/constants'
import { getDealerBrandStatus } from './helper'
import ImportDealersModal from './import_dealers/modal'

const { t } = i18next

const mstp = state => {
  let { total, dealers, show_form, current_dealer, errors } = state.dealers
  let { business_role_priority } = state.userInfo
  let { all_brands: brands } = state.brands
  let { all_users: agents } = state.users
  let { all_categories: categories } = state.categories
  const can_manage = checkCapabilities(['manage_dealers'])
  const can_show = checkCapabilities(['show_dealers'])

  return {
    total,
    dealers,
    show_form,
    current_dealer,
    business_role_priority,
    errors,
    can_manage,
    can_show,
    brands,
    agents,
    categories,
  }
}

class ManageDealers extends React.Component {
  state = {
    show_modal: false,
    ready: false,
    status_filter: 'all',
    status_data_filter: 'all',
    subcode_filter: 'all',
    filtered_brands: [],
    filtered_users: [],
    filtered_categories: [],
    filter: '',
    mode: '',

    filters_hash: '',
  }

  dealer_statuses = []
  dealer_data_statuses = []
  tableRef = null
  selectAgentsModalRef = null
  importDealersModalRef = null
  initialFiltersHash = ''

  constructor(props) {
    super(props)
    let { dealer_statuses, dealer_data_statuses } = getConstants()
    Object.keys(dealer_statuses).forEach(key => {
      this.dealer_statuses.push({ id: key, name: dealer_statuses[key] })
    })
    Object.keys(dealer_data_statuses).forEach(key => {
      this.dealer_data_statuses.push({ id: key, name: dealer_data_statuses[key] })
    })
    this.tableRef = React.createRef()
    this.selectAgentsModalRef = React.createRef()
    this.importDealersModalRef = React.createRef()
  }
  async componentDidMount() {
    await this.props.dispatch(getAllBrands())
    await this.props.dispatch(getAllCategories())
    await this.props.dispatch(getAllUsers({ filtered_roles_priority: [4] }))
    this.setState(
      {
        filtered_brands: this.props.brands.map(b => b.id),
        filtered_users: this.props.agents.map(u => u.id),
        filtered_categories: this.props.categories.map(c => c.id),
        ready: true,
      },
      () => {
        let {
          status_filter,
          subcode_filter,
          status_data_filter,
          filtered_brands,
          filtered_users,
          filtered_categories,
        } = this.state
        filtered_brands.sort()
        filtered_users.sort()
        filtered_categories.sort()

        this.initialFiltersHash = hash({
          status_filter,
          status_data_filter,
          subcode_filter,
          filtered_brands: filtered_brands,
          filtered_users: filtered_users,
          filtered_categories: filtered_categories,
        })
        this.updateFiltersHash()
        this.tableRef?.current?.refreshData()
      }
    )
  }

  updateFiltersHash = () => {
    let { status_filter, subcode_filter, status_data_filter, filtered_brands, filtered_users, filtered_categories } =
      this.state
    filtered_brands.sort()
    filtered_users.sort()
    filtered_categories.sort()
    this.setState({
      filters_hash: hash({
        status_filter,
        subcode_filter,
        status_data_filter,
        filtered_brands,
        filtered_users,
        filtered_categories,
      }),
    })
  }

  actions = [
    {
      icon: 'fas fa-eye',
      variant: 'outline-primary',
      text: t('actions.view', 'Visualizza'),
      visible: () => this.props.can_show,
      onClick: rowData => {
        this.setState({ mode: 'view' })
        this.props.dispatch(setCurrentDealer({ ...rowData }))
        this.props.dispatch(toggleShowForm())
      },
    },
    {
      icon: 'fas fa-edit',
      variant: 'outline-warning',
      text: t('actions.edit', 'Modifica'),
      visible: () => this.props.can_manage,
      onClick: rowData => {
        this.props.dispatch(setCurrentDealer({ ...rowData }))
        this.props.dispatch(toggleShowForm())
      },
    },
    {
      icon: 'fas fa-trash-alt',
      variant: 'outline-danger',
      text: t('actions.delete', 'Elimina'),
      visible: () => this.props.can_manage,
      onClick: rowData => {
        this.props.dispatch(setCurrentDealer({ ...rowData }))
        this.setState({ show_modal: true })
      },
    },
  ]

  actionsRenderer = ({ rowData }) => {
    return <ActionsDropdown rowData={rowData} actions={this.actions} />
  }

  renderDetails = rowData => {
    const { business_name, piva, address, agent, dealer_brands, subcode } = rowData

    return (
      <Card className="shadow-lg mb-4 border-0 rounded-lg">
        <Card.Body className="text-center pb-2 pt-2">
          {/* Business Name + PIVA */}
          <div className="mb-3">
            <div className="fw-bold">{business_name}</div>
            <div>{piva}</div>
          </div>

          {/* Address */}
          {address && <h6 className="fw-semibold mb-3 d-flex justify-content-center align-items-center">{address}</h6>}

          {/* Agent */}
          {agent && (
            <p className="text-muted mb-3">
              <i className="fas fa-user me-2"></i>
              {agent.first_name} {agent.last_name}
            </p>
          )}

          {/* Dealer Brands (usa la funzione di render che hai) */}
          <div className="mb-3">{this.renderBrandCell(dealer_brands)}</div>

          {/* Subcode (stato attivo/inattivo) */}
          <div>
            <Trans i18nKey={`components.dealers.subcode.${subcode ? 'active' : 'inactive'}`}>
              {subcode ? 'Attivo' : 'Inattivo'}
            </Trans>
          </div>
        </Card.Body>

        <Card.Footer className="text-center bg-light pb-3 pt-3">
          <div className="d-flex justify-content-around flex-wrap">
            {this.actions
              .filter(a => {
                if (typeof a.visible === 'function') {
                  return a.visible(rowData, a)
                }
                return a?.visible ?? true
              })
              .map((action, index) => (
                <Button
                  key={index}
                  variant={action.variant}
                  size="sm"
                  title={action.text}
                  disabled={action?.disabled ?? false}
                  onClick={() => action.onClick(rowData)}>
                  <i className={`${action.icon} me-0`}></i>
                </Button>
              ))}
          </div>
        </Card.Footer>
      </Card>
    )
  }

  renderBrandCell = dealer_brands => {
    return (
      <div>
        {dealer_brands.map(b => {
          let status = getDealerBrandStatus(startOfToday(), b)
          let dotColor = ''
          switch (status) {
            case 'engaged':
              dotColor = '#4CAF50'
              break
            case 'not_engaged':
              dotColor = '#FF5C5C'
              break
            case 'in_progress':
              dotColor = '#FFA500'
              break
            default:
              dotColor = '#FFA500'
              break
          }

          return (
            <div
              key={b.brand.id}
              role="button"
              onClick={() => this.showDetailsBrand(b, dotColor)}
              style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <span
                style={{
                  width: '10px',
                  height: '10px',
                  borderRadius: '50%',
                  backgroundColor: dotColor,
                  display: 'inline-block',
                }}
              />
              <div>
                <strong>{b.brand.name}</strong>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  showDetailsBrand = (dealer_brand, dotColor) => {
    const {
      brand,
      code,
      affiliation_date,
      relationship_end_date,
      contract_rejected_date,
      contract_expires_date,
      appointments_creation_date,
      appointments_concluded_date,
      appointments_rejected_date,
    } = dealer_brand

    showConfirmDialog(
      <>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
          }}>
          <span
            style={{
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              backgroundColor: dotColor,
              display: 'inline-block',
            }}
          />
          <div>
            <strong>{`${brand.name} ${code ? `(${code})` : ''}`}</strong>
          </div>
        </div>
      </>,

      <Alert variant="info" className="mb-0">
        <Alert.Heading>
          <Trans i18nKey="components.dealer_brands_form.contract_info">Informazioni relative al contratto</Trans>
        </Alert.Heading>

        <div>
          <Trans i18nKey="components.dealer_brands.affiliation_date">Data affiliazione</Trans>:{' '}
          {affiliation_date ? format(new Date(affiliation_date), 'dd/MM/yyyy') : '-'}
        </div>

        <div>
          <Trans i18nKey="components.dealer_brands.relationship_end_date">Data fine relazione</Trans>:{' '}
          {relationship_end_date ? format(new Date(relationship_end_date), 'dd/MM/yyyy') : '-'}
        </div>

        <div>
          <Trans i18nKey="components.dealer_brands.contract_rejected_date">Data rifiuto pratica contrattuale</Trans>:{' '}
          {contract_rejected_date ? format(new Date(contract_rejected_date), 'dd/MM/yyyy') : '-'}
        </div>

        <div>
          <Trans i18nKey="components.dealer_brands.contract_expires_date">Data scadenza pratica contrattuale</Trans>:{' '}
          {contract_expires_date ? format(new Date(contract_expires_date), 'dd/MM/yyyy') : '-'}
        </div>

        <Alert.Heading className="mt-3">
          <Trans i18nKey="components.dealer_brands_form.appointments_info">Informazioni relative alla visita</Trans>
        </Alert.Heading>
        <div>
          <Trans i18nKey="components.dealer_brands.appointments_creation_date">Data creazione visita</Trans>:{' '}
          {appointments_creation_date ? format(new Date(appointments_creation_date), 'dd/MM/yyyy') : '-'}
        </div>

        <div>
          <Trans i18nKey="components.dealer_brands.appointments_concluded_date">Data conclusione visita</Trans>:{' '}
          {appointments_concluded_date ? format(new Date(appointments_concluded_date), 'dd/MM/yyyy') : '-'}
        </div>

        <div>
          <Trans i18nKey="components.dealer_brands.appointments_rejected_date">Data rifiuto visita</Trans>:{' '}
          {appointments_rejected_date ? format(new Date(appointments_rejected_date), 'dd/MM/yyyy') : '-'}
        </div>
      </Alert>,
      () => {},
      () => {},
      'secondary',
      t('buttons.close', 'Chiudi'),
      true
    )
  }

  columns = [
    {
      title: '',
      className: 'd-none d-sm-block text-center',
      style: { width: '6%', minWidth: '3rem' },
      data: this.actionsRenderer,
    },
    {
      title: t('components.dealers.business_name', 'Nome Azienda'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '30%' },
      sortable: true,
      sortingKey: 'business_name',
      data: ({ rowData: { business_name, piva } }) => (
        <div>
          <div className="fw-bold">{business_name}</div>
          <div>{piva}</div>
        </div>
      ),
    },
    {
      title: t('components.dealers.address', 'Indirizzo'),
      className: 'd-none d-sm-block text-center',
      style: { width: '30%', minWidth: '7rem' },
      sortable: true,
      sortingKey: 'address',
      data: 'address',
    },
    {
      title: t('components.dealers.agent', 'Funzionario'),
      className: 'd-none d-sm-block text-center',
      style: { width: '15%', minWidth: '7rem' },
      data: ({ rowData }) => {
        if (!rowData.agent) return '-'
        return `${rowData.agent.first_name} ${rowData.agent.last_name}`
      },
    },
    {
      title: t('components.dealers.brand', 'Brand'),
      className: 'd-none d-sm-block text-center',
      style: { width: '15%', minWidth: '7rem' },
      data: ({ rowData: { id, dealer_brands } }) => this.renderBrandCell(dealer_brands),
    },
    {
      title: t('components.dealers.subcode', 'Sottocodice'),
      className: 'd-none d-sm-block text-center',
      style: { width: '15%', minWidth: '7rem' },
      data: ({ rowData: { subcode } }) => (
        <Trans i18nKey={`components.dealers.subcode.${subcode ? 'active' : 'inactive'}`}>
          {subcode ? 'Attivo' : 'Inattivo'}
        </Trans>
      ),
    },
    {
      title: t('components.dealers.details', 'Dettagli'),
      className: 'd-block d-sm-none flex-fill',
      style: { width: '100%' },
      sortable: true,
      data: ({ rowData }) => this.renderDetails(rowData),
    },
  ]

  onFilterChange = filter => this.setState({ filter })

  getData = async (index = 0, chunkSize, sortData, filter) => {
    let {
      ready,
      status_filter,
      subcode_filter,
      status_data_filter,
      filtered_brands,
      filtered_users,
      filtered_categories,
    } = this.state
    if (!ready) return
    await this.props.dispatch(
      getDealers({
        offset: index,
        limit: chunkSize,
        sortData,
        filter,
        status_filter,
        subcode_filter,
        status_data_filter,
        filtered_brands,
        filtered_users,
        filtered_categories,
      })
    )
  }

  saveDealer = async dealer => {
    dealer.id
      ? await this.props.dispatch(updateDealer({ dealer }))
      : await this.props.dispatch(createDealer({ dealer }))
    this.tableRef.current.refreshData()
  }

  onToggleForm = () => {
    if (this.props.show_form === true) {
      this.setState({ mode: '' })
      this.props.dispatch(resetCurrentDealer())
    }
    this.props.dispatch(toggleShowForm())
  }

  onCancel = () => {
    this.props.dispatch(resetCurrentDealer())
    this.setState({ show_modal: false })
  }

  onConfirmDelete = async () => {
    await this.props.dispatch(deleteDealer({ tenant: this.props.tenant, id: this.props.current_dealer.id }))
    this.tableRef.current.refreshData()
    this.setState({ show_modal: false })
  }

  componentWillUnmount() {
    this.props.dispatch(resetDealers())
  }

  handleUpdateErrors = errors => {
    this.props.dispatch(updateErrors(errors))
  }

  onChangeFilter = name => values => {
    if (name === 'filtered_users') {
      values = values.map(user => user.id)
    }
    this.setState({ [name]: values }, () => {
      this.tableRef?.current?.refreshData()
      this.updateFiltersHash()
    })
  }

  onResetFilters = () => {
    this.setState(
      {
        status_filter: 'all',
        status_data_filter: 'all',
        filtered_brands: this.props.brands.map(b => b.id),
        filtered_categories: this.props.categories.map(a => a.id),
        filtered_users: this.props.agents.map(u => u.id),
      },
      () => {
        this.tableRef?.current?.refreshData()
        this.updateFiltersHash()
      }
    )
  }

  openImportModal = () => {
    this.importDealersModalRef?.current?.show()
  }

  importHandler = async data => {
    let { dealers, brand, operation_type } = data
    try {
      let url = operation_type === 'import' ? '/api/dealers/import_new' : '/api/dealers/import_update'
      let response = await axios({
        url,
        method: 'post',
        data: { dealers, brand },
      })
      this.tableRef.current.refreshData()
      return response.data
    } catch (err) {
      return { error: t('components.dealers.import_error', "Errore durante l'importazione") }
    }
  }

  render() {
    let {
      show_modal,
      mode,
      filter,
      status_filter,
      subcode_filter,
      status_data_filter,
      filters_hash,
      filtered_brands,
      filtered_users,
      filtered_categories,
    } = this.state
    let { current_dealer, show_form, total, dealers, errors } = this.props

    let title = t('components.dealers.create_dealer', 'Crea dealer')
    if (current_dealer.id) {
      title =
        mode === 'view'
          ? t('components.dealers.view_dealer', 'Visualizza dealer')
          : t('components.dealers.edit_dealer', 'Modifica dealer')
    }
    return (
      <div className="card card-body container-fluid flex-fill d-flex flex-column px-0 pb-0 pt-2 mb-0">
        <div className="d-flex flex-column flex-fill">
          <div className="toolbar px-2">
            <WithCapabilitiesWrapper has={['manage_dealers']}>
              <Button size="sm" onClick={this.onToggleForm} disabled={this.props.show_form}>
                <i className="fas fa-plus fa-fw text-start me-0 ps-1 ps-sm-0" />
                <span className="d-none d-sm-inline">
                  <Trans i18nKey="buttons.add_dealer">Aggiungi dealer</Trans>
                </span>
              </Button>
            </WithCapabilitiesWrapper>

            <FilterGroup className="toolbar-item me-md-3">
              <RadiolistFilter
                label={t('filter_status', 'Stato')}
                items={this.dealer_statuses}
                value={status_filter}
                onChangeFilter={this.onChangeFilter('status_filter')}
                disabled={this.props.show_form}
              />
              <RadiolistFilter
                label={t('subcode_filter', 'Sottocodice')}
                items={this.dealer_statuses}
                value={subcode_filter}
                onChangeFilter={this.onChangeFilter('subcode_filter')}
                disabled={this.props.show_form}
              />
              <RadiolistFilter
                label={t('filter_status_data', 'Stato dato')}
                items={this.dealer_data_statuses}
                value={status_data_filter}
                onChangeFilter={this.onChangeFilter('status_data_filter')}
                disabled={this.props.show_form}
              />
            </FilterGroup>
            <FilterGroup
              className="toolbar-item"
              showResetFilters={this.initialFiltersHash !== filters_hash}
              onResetFilters={this.onResetFilters}>
              <CheckboxFilter
                label={t('filter_brands', 'Brand')}
                items={this.props.brands}
                filteredItems={filtered_brands}
                onChangeFilter={this.onChangeFilter('filtered_brands')}
                showSearch={true}
              />
              <CheckboxFilter
                label={t('filter_categories', 'Categorie')}
                items={this.props.categories}
                filteredItems={filtered_categories}
                onChangeFilter={this.onChangeFilter('filtered_categories')}
                showSearch={true}
              />
              {this.props.agents.length > 0 && (
                <Button
                  className="dropdown-toggle btn btn-primary"
                  onClick={() => this.selectAgentsModalRef.current.show({ selected_users: filtered_users })}>
                  <Trans i18nKey="filter_agents">Funzionari</Trans>
                </Button>
              )}
            </FilterGroup>
            <DropdownButton
              className="toolbar-item"
              disabled={this.props.show_form}
              title={
                <>
                  <i className="fas fa-bars fa-fw text-start" />
                  <Trans i18nKey="components.dealers.actions">Azioni</Trans>
                </>
              }>
              <Dropdown.Item onClick={this.openImportModal}>
                <i className="fas fa-upload" />
                <Trans i18nKey="components.dealers.import">Importa da excel</Trans>
              </Dropdown.Item>
            </DropdownButton>

            <div className="flex-fill">
              <SearchButton
                value={this.state.filter}
                onChange={this.onFilterChange}
                disabled={this.props.show_form}
                className="float-md-end"
              />
            </div>
          </div>

          <ResponsiveTable
            ref={this.tableRef}
            className="flex-fill"
            data={dealers}
            getData={this.getData}
            totalRecords={total}
            columns={this.columns}
            showMenu={show_form}
            modalSize="xl"
            menuContent={DealerForm}
            menuContentProps={{
              title: title,
              dealer: current_dealer,
              brands: this.props.brands,
              agents: this.props.agents,
              categories: this.props.categories,
              business_role_priority: this.props.business_role_priority,
              errors: errors,
              onSave: this.saveDealer,
              closeForm: this.onToggleForm,
              updateErrors: this.handleUpdateErrors,
              forceUseModal: true,
              readonly: mode === 'view',
            }}
            rowClasses={rowData => (rowData.enabled ? '' : `text-muted`)}
            filter={filter}
          />
        </div>

        <Modal backdrop="static" centered show={show_modal} onHide={this.onCancel}>
          <Modal.Header>
            <Modal.Title>
              <Trans i18nKey="components.dealers.delete_dealer_modal.title">Elimina dealer</Trans>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              <Trans
                i18nKey="components.dealers.delete_dealer_modal.description"
                values={{ dealer: this.props.current_dealer?.business_name }}
                defaults={`Per procedere all'eliminazione del dealer <b>{{dealer}}</b>, cliccare sul bottone "Elimina"`}
                components={{ 1: <b /> }}
              />
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onCancel} variant="secondary">
              <Trans i18nKey="buttons.cancel">Annulla</Trans>
            </Button>
            <Button onClick={this.onConfirmDelete} variant="danger">
              <Trans i18nKey="buttons.delete">Elimina</Trans>
            </Button>
          </Modal.Footer>
        </Modal>

        <SelectAgentsModal
          ref={this.selectAgentsModalRef}
          users={this.props.agents}
          brands={this.props.brands}
          selected_user={filtered_users}
          onChange={this.onChangeFilter('filtered_users')}
          multiSelection={true}
        />

        <ImportDealersModal
          ref={this.importDealersModalRef}
          importHandler={this.importHandler}
          brands={this.props.brands}
        />
      </div>
    )
  }
}

export default connect(mstp)(ManageDealers)
